// @ts-nocheck
// project import
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => (
  <SimpleBar
    sx={{
      px: 0.75,
      pb: 1.25,
      pt: 0.5,
      '& .simplebar-content': {
        display: 'flex',
        flexDirection: 'column'
      },
      '& .simplebar-content-wrapper': {
        overflowX: 'hidden !important'
      }
    }}
  >
    <Navigation />
  </SimpleBar>
);

export default DrawerContent;
